const SNAPMINT_CONTENT_SELECTOR = '.product__content';
const SNAPMINT_ANCHOR_SELECTOR = '.product-expected-delivery';
const SNAPMINT_WIDGET_SELECTOR = '[id="sm-widget-btn"], .second_widget_btn';

document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector(SNAPMINT_CONTENT_SELECTOR);
  const anchor = content?.querySelector(SNAPMINT_ANCHOR_SELECTOR);

  if (!anchor || content.dataset.snapmintRelocate) return;

  content.dataset.snapmintRelocate = 'true';

  const isPlaced = (widget) => {
    let sibling = anchor.nextElementSibling;

    while (sibling?.matches(SNAPMINT_WIDGET_SELECTOR)) {
      if (sibling === widget) return true;
      sibling = sibling.nextElementSibling;
    }

    return false;
  };

  const relocate = (widget) => {
    if (isPlaced(widget)) return;

    let reference = anchor;

    while (reference.nextElementSibling?.matches(SNAPMINT_WIDGET_SELECTOR)) {
      reference = reference.nextElementSibling;
    }

    reference.after(widget);
  };

  for (const widget of content.querySelectorAll(SNAPMINT_WIDGET_SELECTOR)) relocate(widget);

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && node.matches(SNAPMINT_WIDGET_SELECTOR)) relocate(node);
      }
    }
  }).observe(content, { childList: true, subtree: true });
});
